// TradingViewWidget.jsx
import React, { useEffect, useRef, memo } from 'react';

function TradingViewWidget() {
  const container = useRef();
  const isSet  =  useRef(false);
  useEffect(
    () => {
     if( !isSet.current){
      const script = document.createElement("script");
      script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML = `
        {
          "autosize": true,
          "symbol": "NASDAQ:AAPL",
          "interval": "D",
          "timezone": "BTC/USDT",
          "theme": "light",
          "style": "1",
          "locale": "en",
          "enable_publishing": false,
        //   "backgroundColor": "rgba(207, 226, 243, 1)",
          "allow_symbol_change": true,
          "calendar": false,
          "support_host": "https://www.tradingview.com"
        }`;
      container.current.appendChild(script);
      isSet.current = true
     }
     
    },
    []);

  return (
    <div className="tradingview-widget-container" ref={container} style={{ height: "600px", width: "100%" }}>
      <div className="tradingview-widget-container__widget" style={{ height: "calc(100% - 32px)", width: "100%" }}></div>
      {/* <div className="tradingview-widget-copyright"><a href="https://www.tradingview.com/" rel="noopener nofollow" target="_blank">
        
        <span className="blue-text">Track all markets on TradingView</span>
        
        </a></div> */}
    </div>
  );
}

export default memo(TradingViewWidget);
